exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".mainContainer-3wuo7{display:-webkit-box;display:-ms-flexbox;display:flex}.menu-3iSCA{display:-webkit-box;display:-ms-flexbox;display:flex}.linkContainer-2Wygv{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center}.navLink-1rBKw{font-weight:600;margin:0px 8px;text-align:center}.navLink-1rBKw.light-1hqsx{color:#39395b}.navLink-1rBKw.active-Xzc-W{color:#1fadff;-webkit-text-decoration:revert;text-decoration:revert}.navLink-1rBKw.disabled-193EA{color:#9196af !important;cursor:not-allowed}", ""]);

// exports
exports.locals = {
	"mainContainer": "mainContainer-3wuo7",
	"menu": "menu-3iSCA",
	"linkContainer": "linkContainer-2Wygv",
	"navLink": "navLink-1rBKw",
	"light": "light-1hqsx",
	"active": "active-Xzc-W",
	"disabled": "disabled-193EA"
};